import React from 'react'

export default ({ color, className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="_x32_" x="0px" y="0px" viewBox="0 0 512 512" className={className}>
        <g>
            <path style={{ fill: color }} d="M448.231,166.755C352.139,64.989,240.998,2.38,240.998,2.38c-3.297-2.625-7.813-3.125-11.609-1.281   c-3.813,1.844-6.219,5.688-6.219,9.906v329c-20.078-8.281-44.688-11.656-71.344-8.344C84.717,340.005,30.514,386.849,30.67,436.255   c0.188,49.453,54.703,82.813,121.75,74.469c67.078-8.328,121.297-55.188,121.125-104.641V164.817   c15.828,3.313,34.391,10.531,54.391,25.219c67.703,49.625,100.905,81.484,58.218,166.859   C475.403,321.974,514.2,236.599,448.231,166.755z"/>
        </g>
    </svg>
)
